export const Logo = ({ dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <img
      src="/logo.png"
      alt="EduPower Foundation logo"
      className="h-20 w-20 shrink-0 rounded-2xl object-cover shadow-md sm:h-24 sm:w-24 lg:h-28 lg:w-28"
    />
    <div className="leading-none">
      <span
        className={`font-display font-black tracking-wider text-3xl block sm:text-5xl lg:text-7xl ${dark ? "text-sand" : "text-coal"}`}
        style={{ WebkitTextStroke: dark ? "1px #FBF9F5" : "1px #1A1D24" }}
      >
        EDUPOWER
      </span>
      <span className="font-mono-brand text-sm tracking-[0.7em] text-ember font-black sm:text-lg lg:text-xl">FOUNDATION</span>
      <span className={`font-mono-brand text-[9px] tracking-[0.2em] font-black block mt-0.5 sm:text-xs lg:text-sm ${dark ? "text-sand/80" : "text-coal-muted"}`}>
        CAPE TOWN, EST. 2022
      </span>
    </div>
  </div>
);
